import React, { useState, useEffect } from 'react';
import HomeComponentMobile from './HomeComponentMobile';
import HomeComponentNew from './HomeComponentNew';

function Home() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div>
      {isMobile ? <HomeComponentMobile /> : <HomeComponentNew />}
    </div>
  );
}

export default Home;
